var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "app-launcher-warning" } },
    [
      _vm.emoji
        ? _c("div", { staticClass: "emoji-image" }, [
            _vm._v("\n    " + _vm._s(_vm.emoji) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ]),
      _vm._v(" "),
      _vm.description
        ? _c("div", { staticClass: "description" }, [
            _vm._v("\n    " + _vm._s(_vm.description) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("app-launcher-warning-actions", {
        attrs: {
          "app-state": _vm.appState,
          "app-error": _vm.appError,
          "v-suggest": _vm.vSuggest,
          "is-updating": _vm.isUpdating,
          "is-loading": _vm.isLoading,
          "is-user-an-admin": _vm.isUserAnAdmin,
        },
        on: {
          "app-install": function ($event) {
            return _vm.$emit("app-install")
          },
          "app-update": function ($event) {
            return _vm.$emit("app-update")
          },
          "accept-version": function ($event) {
            return _vm.$emit("accept-version")
          },
          "retry-update": function ($event) {
            return _vm.$emit("retry-update")
          },
          update: function ($event) {
            return _vm.$emit("update")
          },
          cancel: function ($event) {
            return _vm.$emit("cancel")
          },
          "go-to-launcher": function ($event) {
            return _vm.$emit("go-to-launcher")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }